<template>
  <main ref='body'>
    <router-view />
  </main>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router'
import { watch, ref, onMounted, onUnmounted } from 'vue'
import Veil from './components/Veil.vue'
import RouterViewWithTransitions from './components/ViewTransitions.vue'
import { useStore } from './KQL.js'
import { useTitle } from 'vue-page-title';

const route = useRoute()
const router = useRouter()

const kql = useStore();
setTimeout(function() { kql.loadPageAndSite(route.path, route.name) });

watch(route, (route) => {
  if (route.name === 'Home') return;
  kql.loadPage(route.path, route.name);
});

const { setTitle } = useTitle();
watch(kql, () => {
  if (kql.page?.title) setTitle(kql.page.title);
});

function onLinkClick(e) {
  if (e.defaultPrevented) return;
  const anchor = e.target.closest('a[href]');
  if (!anchor) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  if (anchor.target === '_blank') return;
  const href = anchor.getAttribute('href');
  if (!href || href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('#') || href.startsWith('/ics/')) return;
  e.preventDefault();
  router.push(href);
}

onMounted(() => document.addEventListener('click', onLinkClick));
onUnmounted(() => document.removeEventListener('click', onLinkClick));
</script>

<style scoped>
</style>
